import { render, staticRenderFns } from "./Scorer.vue?vue&type=template&id=402d2172&"
import script from "./Scorer.vue?vue&type=script&lang=ts&"
export * from "./Scorer.vue?vue&type=script&lang=ts&"
import style0 from "./Scorer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports